import { __rest } from "tslib";
import React from 'react';
import DropdownComponent from '../../../Dropdown/Dropdown';
import { useCityOptions } from '../../../LocationAutocomplete/hooks';
import LocationOptionsList from '../LocationOptionsList/LocationOptionsList';
const Dropdown = (_a) => {
    var { options, isOpen, onClose, onClickOutsideProps, onAdditionalButtonClick } = _a, listProps = __rest(_a, ["options", "isOpen", "onClose", "onClickOutsideProps", "onAdditionalButtonClick"]);
    const { dropdownOptions, showAdditionalButton } = useCityOptions(options);
    return (React.createElement(DropdownComponent, Object.assign({}, onClickOutsideProps, { keepMounted: true, isOpen: options.length && isOpen, onClose: onClose }),
        React.createElement(LocationOptionsList, Object.assign({ options: dropdownOptions, showButton: showAdditionalButton, onButtonClick: onAdditionalButtonClick }, listProps))));
};
export default Dropdown;
